<!-- We do not use semantic-ui classes here because they are blocks and vertically aligned by default -->
<div class="list-card-container">
    <i class="ui icon {{icon}}"></i>
    <p>{{description}}</p>
</div>